export default "__VITE_ASSET__DJBXUgWk__"